define('viewmodels/account/login',['plugins/router', 'services/logger', 'services/appsecurity', 'durandal/system', 'viewmodels/GeneralSettings'],
    function (router, logger, appsecurity, system, ObjGeneralSettings) {
        var vm = {
            returnUrl: ko.observable(null),
            rememberMe: ko.observable(false),
            userName: ko.observable(),
            forgetUserName: ko.observable(),
            errorMessage: ko.observable(),
            ShowForgotPassword: ShowForgotPassword,
            ShowLogin: ShowLogin,
            password: ko.observable(),
            PrivacyContent: PrivacyContent,
            UserSupportContent: UserSupportContent,
            CookiesContent: CookiesContent,
            ContanctUs: ko.observable(),
            homeUrl: ko.observable(''),
            getLanguagesApp: getLanguagesApp,
            SelectedLanguage: ko.observable(''),
            ChangeLocaleLogin: ChangeLocaleLogin,
            LanguageListApp: ko.observableArray([]),
            LocaleCheckFlag: ko.observable(false),
            LocalizedTextList: ko.observableArray([]),
            LocalizedIndexList: ko.observableArray([]),
            ExternalAzureLogin: ExternalAzureLogin,
            SSOurlforLogin: ko.observable(''),
            FooterText: ko.observable(''),

            activate: function (splat) {
                var self = this;
                if (splat && splat.returnUrl) {
                    self.returnUrl(splat.returnUrl);
                    self.from(splat.from);
                }
                GetSSOURLfromConfig();
                getLanguagesApp();

                // If requested route is logout, make a call to account controller to sign-out the user
                if (router.activeInstruction().fragment.toLowerCase() == 'logout') {
                    if (typeof (appsecurity.userInfo()) !== 'undefined') {
                        appsecurity.logout(ko.toJSON({ refreshToken: true }))
                            .done(function (token) {
                                $("input[name='__RequestVerificationToken']").val(token);
                            });
                    }
                    var loginRoute = self.returnUrl() ? 'login?returnUrl=' + encodeURIComponent(self.returnUrl()) + '&from=' + self.from() : 'login';
                    router.navigate(loginRoute, { replace: true, trigger: false });
                }
                appsecurity.clearAuthInfo();
            },
            attached: function () {

                $('#loginPageLogo').hide();
                $('#loadingMainImgDiv').hide();
                $("#txtPassword").val('');
                $("body").removeClass("login-container").addClass("login");
                $("#shellWrapper").removeClass("wrapper");
                $("#shellWrapper").removeClass("content-wrapper");
                $(".main-sidebar").hide();
                $("#master-header-content").removeClass("content-wrapper");
                $('body').addClass("login-page hold-transition");
                DefaultButton =
                    $("header").css({ "display": "none" });
                var url = window.location.href,
                    suburl = url.substring(url.lastIndexOf('/') + 1);

                if (suburl != "") {
                    url = url.replace(suburl, '');
                }
                if (url != "")
                    url = url.substring(0, url.lastIndexOf('/'));

                vm.homeUrl(url);
                $('#sessionTimer').modal('hide');
                GetLoginCopyrightText(1); //English

            },
            detached: function () {
                $("body").removeClass("login").addClass("login-container");
                $('body').addClass("login-page hold-transition");
                $("header").css({ "display": "block" });
            },
            logger: logger,
            filename: ko.observable('login'),
            resetFields: function () {
                $('#txtUserName').val("");
                $('#txtPassword').val("");
            },
            login: login,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings
        };

        return vm;

        function ExternalAzureLogin() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Account/AzureExtLogin",
                    type: "GET",
                    headers: headers,
                })
                    .success(function (jsonResult, error) {
                        appsecurity.IsExternalLogin(true);
                        window.location.href = jsonResult;
                        return false;
                    })
                    .fail(function (error, status) {
                        logger.logError((!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('AnErrorOccuredMsg') == -1) ? 'An error has occurred. Please contact your Administrator.' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('AnErrorOccuredMsg')].Name(), 'Error', system.getModuleId(vm), true);                                //logger.logError('No data available for Contact us.', 'Warning', system.getModuleId(vm), true);
                    })

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExternalAzureLogin() method in login.js';
                logger.logMessage(msg);
            }
        }

        function login() {
            //try {
            $('#loginBox').hide();
            $('#LoginMessageLabel').hide();
            $('#loadingMainImgDiv').show();
            $("#lblBlankUserName").hide();
            $("#lblBlankPassword").hide();
            var pattern = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[@@#.$%&^*!()]).*$/;
            document.getElementById('lblBlankPassword').innerHTML = (!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('Required') == -1) ? '*Required' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('Required')].Name();
            var self = this;
            if ($("#txtUserName").val().length === 0 && $("#txtPassword").val().length === 0) {
                $("#lblBlankUserName").show();
                $("#lblBlankPassword").show();

                $('#LoginMessageLabel').show();
                $('#loadingMainImgDiv').hide();
                $('#loginBox').show();
            }
            else if ($("#txtUserName").val().length === 0) {
                $("#lblBlankUserName").show();
                $("#lblBlankPassword").hide();

                $('#LoginMessageLabel').show();
                $('#loadingMainImgDiv').hide();
                $('#loginBox').show();
            }
            else if ($("#txtPassword").val().length === 0) {
                $("#lblBlankUserName").hide();
                $("#lblBlankPassword").show();

                $('#LoginMessageLabel').show();
                $('#loadingMainImgDiv').hide();
                $('#loginBox').show();
            }
            else if ($("#txtPassword").val().length > 0 && $("#txtPassword").val().length < 8) {
                $("#lblBlankUserName").hide();
                document.getElementById('lblBlankPassword').innerHTML = (!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('enter8characters') == -1) ? 'Please enter at least 8 characters.' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('enter8characters')].Name();
                $("#lblBlankPassword").show();


                $('#LoginMessageLabel').show();
                $('#loadingMainImgDiv').hide();
                $('#loginBox').show();
            }
            else if (!pattern.test($('#txtPassword').val())) {
                $("#lblBlankUserName").hide();
                document.getElementById('lblBlankPassword').innerHTML = (!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('PasswordSuggest') == -1) ? 'Your password must be at least 8 characters long. 1 uppercase, 1 lowercase, 1 special character & 1 number' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('PasswordSuggest')].Name();
                $("#lblBlankPassword").show();


                $('#LoginMessageLabel').show();
                $('#loadingMainImgDiv').hide();
                $('#loginBox').show();
            }
            else {
                var key = CryptoJS.enc.Utf8.parse('8080808080808080');
                var iv = CryptoJS.enc.Utf8.parse('8080808080808080');
                var encrypteduserName = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(vm.userName()), key,
                    {
                        keySize: 128 / 8,
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7
                    });
                $('#txtencryption').val(encrypteduserName);
                var username = $('#txtencryption').val();

                var encryptedpassword = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(vm.password()), key,
                    {
                        keySize: 128 / 8,
                        iv: iv,
                        mode: CryptoJS.mode.CBC,
                        padding: CryptoJS.pad.Pkcs7
                    });
                $('#txtencryption').val(encryptedpassword);
                var password = $('#txtencryption').val();
                appsecurity.login({
                    grant_type: 'password',
                    username: username,
                    password: password,
                    //client_id: 'webApp'
                }).done(function (data) {
                    $('#loginBox').show();
                    $('#loadingMainImgDiv').hide();
                    vm.errorMessage('');
                    if (data.userName && data.access_token) {

                        appsecurity.CountDownTime(data['.expires']);
                        //appsecurity.setAuthenticationInfo(data.access_token, data.refresh_token, data['.expires'], self.rememberMe());
                        //appsecurity.refreshAFToken().done(function (data) {
                        //    $("input[name='__RequestVerificationToken']").val(data);
                        //});
                        appsecurity.MFAat(data.access_token)
                        appsecurity.MFArt(data.refresh_token)
                        appsecurity.rMe(self.rememberMe())
                        appsecurity.expMFA(data['.expires'])

                        appsecurity.TwofactorEnabled(data.TwoFactorEnabled)
                        if (data.TwoFactorEnabled == "True") {
                            appsecurity.TwofactorEnabled(data.TwoFactorEnabled)
                            appsecurity.ProjectCount(data.ProjectCount);
                            appsecurity.Phonenumberverified(data.PhoneNumbervalid);
                            appsecurity.EmailId(data.email);
                            router.navigate('AuthorizeMFA');
                        }
                        else if (data.ProjectCount == 1) {

                            // Set the authentication info
                            appsecurity.setAuthenticationInfo(data.access_token, data.refresh_token, data['.expires'], self.rememberMe());
                            appsecurity.refreshAFToken().done(function (data) {
                                $("input[name='__RequestVerificationToken']").val(data);
                            });

                            var moduleList = JSON.parse(data.moduleList);
                            appsecurity.setUserInfo(data.userName, data.primaryRoleID, data.primaryRoleName, data.secondaryRoleID, data.secondaryRoleName, moduleList, data.fullName, data.firstName, data.lastName, self.rememberMe(), data.ProjectCount, data.Phonenumberverified, data.TwoFactorEnabled, data.email);

                            //refresh token
                            if (self.returnUrl()) {
                                router.navigate(self.returnUrl());
                            } else {

                                //if (self.passwordChanged().toString().toLowerCase() == '0') {
                                //    router.navigate("/account/changepassword");
                                //}
                                //else {
                                //    router.navigate("/home/index");
                                //    //router.navigate("/home/permission");
                                //}
                            }


                            // Need to set modulelist, pagelist and folderlist as per the current implementation

                            // change starts
                            var MappedModuleList = "";
                            var MappedPageList = "";
                            var MappedFolderList = "";
                            for (var i = 0; i < moduleList.length; i++) {
                                MappedModuleList += moduleList[i].ModuleCodeName + ";";
                                for (var j = 0; j < moduleList[i].PageList.length; j++) {
                                    MappedPageList += moduleList[i].PageList[j].PageCodeName + ";";
                                    MappedFolderList += moduleList[i].PageList[j].FolderName + ";";
                                }
                            }
                            appsecurity.ModuleList(MappedModuleList);
                            appsecurity.PageList(MappedPageList);
                            appsecurity.FolderList(MappedFolderList);
                            appsecurity.ConfigurationAccess(false);
                            if ((appsecurity.PageList() != undefined) && (appsecurity.PageList().indexOf('ConfigurationFreeze') >= 0)) {
                                for (var i = 0; i < appsecurity.userInfo().moduleList().length; i++) {
                                    for (var j = 0; j < appsecurity.userInfo().moduleList()[i].PageList().length; j++) {
                                        if (appsecurity.userInfo().moduleList()[i].PageList()[j].PageCodeName() == "ConfigurationFreeze" && appsecurity.userInfo().moduleList()[i].PageList()[j].WriteAccess() == 'true')
                                            appsecurity.ConfigurationAccess(true);
                                    }
                                }

                            }
                            else
                                appsecurity.ConfigurationAccess(false);


                            if (self.returnUrl()) {
                                // If return URL is a HTTP(S) URL, send the url as route parameter to landing page, else navigate to the return url
                                if (self.returnUrl().match(/^http([s]?):\/\/.*/)) {
                                    router.navigate('landing?returnUrl=' + encodeURIComponent(self.returnUrl()) + '&from=' + self.from());
                                    //localization code
                                    appsecurity.GetCurrentLocaleOfUser().then(function () {
                                        if (appsecurity.CurrentLocaleOfUserFromLoginId() != "1" && appsecurity.CurrentLocaleOfUserFromLoginId() != "" && appsecurity.CurrentLocaleOfUser() != appsecurity.CurrentLocaleOfUserFromLoginId()) {
                                            ChangeLocaleForUser(appsecurity.CurrentLocaleOfUserFromLoginId());
                                            GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of previosly saved language id

                                        } else {
                                            GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of login page selection language id
                                        }
                                    });
                                }
                                else {
                                    router.navigate(self.returnUrl());
                                    //localization code
                                    appsecurity.GetCurrentLocaleOfUser().then(function () {
                                        if (appsecurity.CurrentLocaleOfUserFromLoginId() != "1" && appsecurity.CurrentLocaleOfUserFromLoginId() != "" && appsecurity.CurrentLocaleOfUser() != appsecurity.CurrentLocaleOfUserFromLoginId()) {
                                            ChangeLocaleForUser(appsecurity.CurrentLocaleOfUserFromLoginId());
                                            GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of previosly saved language id

                                        }
                                        else {
                                            GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of login page selection language id
                                        }
                                    });
                                }
                            }
                            else if (parseInt(data.ProjectCount) > 1) {
                                router.navigate('ProjectLanding');
                                //localization code
                                appsecurity.GetCurrentLocaleOfUser().then(function () {
                                    if (appsecurity.CurrentLocaleOfUserFromLoginId() != "1" && appsecurity.CurrentLocaleOfUserFromLoginId() != "" && appsecurity.CurrentLocaleOfUser() != appsecurity.CurrentLocaleOfUserFromLoginId()) {
                                        ChangeLocaleForUser(appsecurity.CurrentLocaleOfUserFromLoginId());
                                        GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of previosly saved language id

                                    }
                                    else {
                                        GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of login page selection language id
                                    }
                                });
                            }
                            else {
                                router.navigate('Landing');
                                //localization code
                                appsecurity.GetCurrentLocaleOfUser().then(function () {
                                    if (appsecurity.CurrentLocaleOfUserFromLoginId() != "1" && appsecurity.CurrentLocaleOfUserFromLoginId() != "" && appsecurity.CurrentLocaleOfUser() != appsecurity.CurrentLocaleOfUserFromLoginId()) {
                                        ChangeLocaleForUser(appsecurity.CurrentLocaleOfUserFromLoginId());
                                        GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of previosly saved language id

                                    }
                                    else {
                                        GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of login page selection language id
                                    }
                                });
                            }
                            vm.resetFields();

                        }
                        else if (data.ProjectCount > 1) {
                            appsecurity.setAuthenticationInfo(data.access_token, data.refresh_token, data['.expires'], self.rememberMe());
                            appsecurity.refreshAFToken().done(function (data) {
                                $("input[name='__RequestVerificationToken']").val(data);
                            });

                            $('#loginPageLogo').hide();
                            appsecurity.ProjectCount = data.ProjectCount;
                            router.navigate('ProjectLanding');

                            //localization code
                            appsecurity.GetCurrentLocaleOfUser().then(function () {
                                if (appsecurity.CurrentLocaleOfUserFromLoginId() != "1" && appsecurity.CurrentLocaleOfUserFromLoginId() != "" && appsecurity.CurrentLocaleOfUser() != appsecurity.CurrentLocaleOfUserFromLoginId()) {
                                    ChangeLocaleForUser(appsecurity.CurrentLocaleOfUserFromLoginId());
                                    GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of previosly saved language id

                                }
                                else {
                                    GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin()); //locale of login page selection language id
                                }
                            });
                        }

                    }
                }).fail(function (error) {
                    $('#loginBox').show();
                    $('#loadingMainImgDiv').hide();
                    vm.errorMessage('');
                    if (error.responseJSON.error_description === 'Invalid Username or Password') {
                        vm.errorMessage((!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('InvalidUserNamePassword') == -1) ? 'Invalid username or password, please check and try again.' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('InvalidUserNamePassword')].Name());

                        $('#LoginMessageLabel').show();
                    }
                    else if (error.responseJSON.error_description !== null) {
                        vm.errorMessage(error.responseJSON.error_description);
                        $('#LoginMessageLabel').show();
                    }
                    else {
                        vm.errorMessage((!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('errorOccurredMsg') == -1) ? 'An error occurred, please try again.' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('errorOccurredMsg')].Name());
                        $('#LoginMessageLabel').show();
                    }
                });
            }

        }
        function GetContactUsInformation() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetUserSupportItem",
                    type: "GET",
                    headers: headers,
                    data: { TypeId: 14 }//14 is the id for contact us data}
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined) {
                            if (jsonResult.length == 0)
                                logger.logMessage((!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('NodataforContactus') == -1) ? 'No data available for Contact us' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('NodataforContactus')].Name(), 'Error', system.getModuleId(vm), true);                                //logger.logError('No data available for Contact us.', 'Warning', system.getModuleId(vm), true);

                            vm.ContanctUs('');
                            appsecurity.ContanctUs('');
                            if (jsonResult.length != 0) {
                                vm.ContanctUs(ko.observable(jsonResult.Description));
                                appsecurity.ContanctUs(ko.observable(jsonResult.Description))
                            }
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError((!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('AnErrorOccuredMsg') == -1) ? 'An error has occurred while fetching the User support. Please contact your Administrator.' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('AnErrorOccuredMsg')].Name(), 'Error', system.getModuleId(vm), true);                                //logger.logError('No data available for Contact us.', 'Warning', system.getModuleId(vm), true);

                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetContactInformation() method in header.js';
                logger.logMessage(msg);
            }
        }

        function GetSSOURLfromConfig() {
            try {
                var headers = appsecurity.getSecurityHeaders();
                return $.ajax({
                    url: "/api/Configuration/GetSSOURLfromConfig",
                    type: "GET",
                    headers: headers,
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != undefined) {

                            vm.SSOurlforLogin('');
                            if (jsonResult != "") {
                                vm.SSOurlforLogin(jsonResult);
                            }
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while fetching the User support. Please contact your Administrator.', 'Error', system.getModuleId(vm), true);
                    })
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetContactInformation() method in header.js';
                logger.logMessage(msg);
            }
        }
        function ShowForgotPassword() {
            appsecurity.UserContent('forgotPwd-content');
            router.navigate('UserManual');
        }

        function ShowLogin() {
            $('#loginBox').show();
            $('#forgotPasswordBox').hide();
            $('#PasswordMessageLabel').hide();
            $('#LoginMessageLabel').hide();
        }


        function PrivacyContent() {
            appsecurity.UserContent('Privacy');
            router.navigate('UserManual');
        }

        function UserSupportContent() {
            appsecurity.UserContent('faqList');
            router.navigate('UserManual');
        }

        function CookiesContent() {
            appsecurity.UserContent('Cookies');
            router.navigate('UserManual');
        }

        function getLanguagesApp() {
            if (vm.LanguageListApp() == undefined || vm.LanguageListApp().length == 0) {
                getLanguages();
            }
        }

        function getLanguages() {
            try {

                $.ajax({
                    url: "/api/Account/GetLanguages",
                    type: "GET",
                    //async: false,
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + 'Source: ajaxCall in GetLanguages() in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null && jsonResult.length > 0) {
                        var mappedLanguages = $.map(jsonResult, function (result) {
                            return new GetLanguagesModel(result);
                        });
                        vm.LanguageListApp(mappedLanguages);
                        vm.appsecurity.LanguageListApp(mappedLanguages);
                    }
                }
                catch (e) {
                    var msg = 'Exception:' + e + '|Source : ajaxSuccess of GetLanguages() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetLanguages() in GeneralSettings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in  GetLanguages() in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetLanguagesModel(item) {
            try {
                var self = this;
                self.LANGUAGE_ID = ko.observable(item.LANGUAGE_ID);
                self.LANGUAGENAME = ko.observable(item.LANGUAGENAME);
                self.LOCALE = ko.observable(item.LOCALE);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetLanguagesModel() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
        }


        function ChangeLocaleLogin(data, event) {
            try {
                var option = document.getElementById("LocaleDropDown").value;
                var langid = 1;
                langid = option.split(' ')[0];

                if (option !== null && option != "" && option != undefined) {
                    appsecurity.CurrentLocaleOfUserFromLoginId(option.split(' ')[0]);
                    appsecurity.CurrentLocaleOfUser(option.split(' ')[0]);

                    if (option.split(" ").length > 1) {
                        appsecurity.CurrentLocaleOfUserFromLogin(option.split(' ')[1]);
                        GetLocalizationDetailsResx(option.split(' ')[1]);
                        GetLoginCopyrightText(langid)
                    }
                }

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ChangeLocaleLogin() method in Login.js';
                logger.logMessage(msg);
            }
        }

        function ChangeLocaleForUser(localeId) {
            try {
                appsecurity.CurrentLocaleOfUser(localeId);
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Account/SaveLocaleSettings?localeId=" + localeId,
                    type: "POST",
                    headers: headers,
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ajax call from SaveSettings() method in GeneralSettings.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (status == 'success') {
                        // appsecurity.CurrentLocaleOfUser(localeId);
                        //GetLocalizationDetailsResx(appsecurity.CurrentLocaleOfUserFromLogin());
                        logger.logMessage('Language Updated successfully.', 'Success', system.getModuleId(vm), true);
                    }
                    else {
                        logger.logMessage('Language update failure. Please contact your Application Administrator.', 'Error', system.getModuleId(vm), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxSuccess method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);

                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source:ajaxFail method in SaveSttings() method in GeneralSettings.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetLocalizationDetailsResx(locale) {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetLocalizationDetailsResx?LocaleCulture=" + locale,
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetLocalizationDetailsResx() method in LocalizationModule.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {

                    //vm.LocalizedIndexList([]);
                    if (jsonResult.length == 0)
                        logger.logMessage('No records present for localized details.', 'Warning', system.getModuleId(vm), true);

                    for (var i = 0; i < jsonResult.length; i++) {
                        vm.LocalizedIndexList().push(jsonResult[i].Identifier);
                    }

                    var MappedGroupDetails = $.map(jsonResult, function (result) {
                        return new LocalizationModel(result);
                    });
                    //vm.LocalizedTextList([]);
                    vm.LocalizedTextList(MappedGroupDetails);
                    if (vm.LocalizedTextList() == undefined || vm.LocalizedTextList() == null || vm.LocalizedTextList().length <= 0 || vm.LocalizedIndexList() == undefined || vm.LocalizedIndexList() == null)
                        vm.LocaleCheckFlag(false);
                    else
                        vm.LocaleCheckFlag(true);

                    vm.appsecurity.LocaleCheckFlag(vm.LocaleCheckFlag());
                    vm.appsecurity.LocalizedTextList(vm.LocalizedTextList());
                    vm.appsecurity.LocalizedIndexList(vm.LocalizedIndexList());
                    vm.ObjGeneralSettings.LocaleCheckFlag(vm.LocaleCheckFlag());
                    vm.ObjGeneralSettings.LocalizedTextList(vm.LocalizedTextList());
                    vm.ObjGeneralSettings.LocalizedIndexList(vm.LocalizedIndexList());
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetLocalizationDetailsResx() method in login.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetLocalizedData() method in LocalizationModule.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetLocalizationDetailsResx() method in login.js';
                    logger.logMessage(msg);
                }
            }
        }
        function LocalizationModel(item) {
            try {
                var self = this;
                self.Name = ko.observable($('<div/>').html(item.Name).text());
                self.NameIdentifier = ko.observable($('<div/>').html(item.Identifier).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: LocalizationModel() method in login.js';
                logger.logMessage(msg);
            }
        }

        function GetLoginCopyrightText(langid) {
            try {
                return $.ajax({
                    url: "/api/Account/GetLoginCopyright",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "LANGID": langid
                    }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult != null && jsonResult != "" && jsonResult.length > 0 && jsonResult.substring(0,3)!="INC") {
                            //vm.FooterText('');
                            vm.FooterText(jsonResult);
                        }

                        else {
                            if (langid == 1)
                            vm.FooterText('Deloitte Development LLC.All rights reserved. <br/> Deloitte refers to one or more of the Deloitte Touche Tohmatsu Limited, a UK private company limited by guarantee(DTTL), its network of member firms, and their related entities.DTTL and each of its member firms are legally separated and independent entities.  <br/> DTTL(also referred to as Deloitte Global) does not provide services to clients.Please see www.deloitte.com / about for more detailed description of DTTL and its member firms.');
                            else 
                                vm.FooterText('Deloitte Development LLC. Todos los derechos reservados.  <br/>Deloitte se refiere a una o algunas del grupo de empresas de Deloitte Touche Tohmatsu Limited (DTLL) y su red de empresas y entidades relacionadas. DTLL es una compania privada limitada por garantia, del Reino Unido. DTTL y cada una de sus empresas estan separadas legalmente y son entidades independientes.  <br/>DTTL (tambien denominada Deloitte Global) no brinda servicios a clientes. Por favor, consulte www.deloitte.com/about para mas informacian sobre DTTL y sus empresas miembros.');
                        //logger.logMessage((!vm.LocaleCheckFlag() || vm.LocalizedIndexList.indexOf('FetchLoginText') == -1) ? 'Some error occured while fetching the Copyright message. Please contact your Administrator.' : vm.LocalizedTextList()[vm.LocalizedIndexList.indexOf('FetchLoginText')].Name().toString(), 'Error', system.getModuleId(vm), true);
                    }
                })
                .fail(function (error,status) {
                    logger.logError((!vm.LocaleCheckFlag() || vm.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchLoginText') == -1) ? 'An error has occurred while fetching the Copyright message. Please contact your Administrator.' : vm.ObjGeneralSettings.LocalizedTextList()[vm.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchLoginText')].Name().toString(), 'Error', system.getModuleId(vm), true);
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetLoginCopyright() method in login.js';
                logger.logMessage(msg);
            }
        }

    }); //End of define method
;
